// extracted by mini-css-extract-plugin
export default {"root":"RadioButton_root__ZB7Kc","disabled":"RadioButton_disabled__X2Bjg"};